/**
 * 決済失敗時にゲストへ見せる文言。
 *
 * backend は PSP 由来のエラーをすべて zerrors.ErrMsgCardPaymentFailed へマスクして返すため、
 * 通常はレスポンスの文言をそのまま表示する。ここは 502 等でレスポンス本文から文言が取れなかった
 * ときの代替で、正本は backend 側（pkg/core/module_shared/domain/zerrors/application_error.go）。
 */
export const CARD_PAYMENT_FAILED_MESSAGE = 'Sorry, we encountered an issue processing your payment. This may be due to incorrect card details or a card that is not accepted for this transaction.';
